import React, { useContext } from 'react';
import { Col } from '@thd-olt-component-react/grid';
import { ProductPodContext } from '../../ProductPodContext';
import { getCustomUrlWithAnalytics } from '../../utils';
import './ProductSample.style.scss';

export const ProductSample = () => {
  const {
    channel,
    hosts,
    product
  } = useContext(ProductPodContext);

  const {
    identifiers,
    info
  } = product || {};

  const {
    canonicalUrl = '',
  } = identifiers || {};

  const sampleAvailable = info?.samplesAvailable;
  const target = channel === 'mobile' ? '_self' : '_blank';

  if (!sampleAvailable) return null;

  return (
    <Col nopadding>
      <a
        className="sampleWrapper"
        href={canonicalUrl}
        target={target}
      >
        <div className="sampleWrapper__icon">
          <img
            src="https://assets.homedepot-static.com/images/v1/more-options.svg"
            alt="more-options-icon"
            className="stretchy"
          />
        </div>
        <span className="sampleWrapper__title">Samples Available</span>
      </a>
    </Col>
  );
};

ProductSample.displayName = 'ProductSample';

export default ProductSample;
